import { IconTitleStyled } from '../DashboardStyled';

interface IconTitleProps {
  icon?: any;
  title?: string;
  total?: any;
}

export const IconTitle = ({ icon, title, total }: IconTitleProps) => (
  <IconTitleStyled>
    {icon && <img src={icon} alt={title} style={{ width: total ? 13 : 32 }} />}
    {title}
  </IconTitleStyled>
);
